export type ChatAnalyticsIntent =
  | 'order_status'
  | 'shipping_delivery'
  | 'returns_refunds'
  | 'product_recommendation'
  | 'product_education'
  | 'cart_checkout'
  | 'discount_promotion'
  | 'subscription_account'
  | 'complaint_issue'
  | 'collaboration_gifting'
  | 'agent_handoff'
  | 'general_support';

const INTENT_PATTERNS: Array<{
  intent: ChatAnalyticsIntent;
  patterns: RegExp[];
}> = [
  {
    intent: 'agent_handoff',
    patterns: [/\b(human|person|representative|agent|customer service|support rep)\b/i],
  },
  {
    intent: 'order_status',
    patterns: [/\b(order|tracking|track|shipment|where is|delivered|package)\b/i],
  },
  {
    intent: 'shipping_delivery',
    patterns: [/\b(ship|shipping|delivery|delayed|lost|stolen|address|wrong address)\b/i],
  },
  {
    intent: 'returns_refunds',
    patterns: [/\b(return|refund|exchange|damaged|cancel)\b/i],
  },
  {
    intent: 'cart_checkout',
    patterns: [/\b(cart|checkout|buy|purchase|add to cart|payment)\b/i],
  },
  {
    intent: 'product_recommendation',
    patterns: [/\b(recommend|best|which|routine|for my skin|skin type|compare)\b/i],
  },
  {
    intent: 'product_education',
    patterns: [/\b(ingredient|how to use|directions|pilling|pregnan|safe|sensitive|spf)\b/i],
  },
  {
    intent: 'discount_promotion',
    patterns: [/\b(discount|promo|coupon|code|sale|offer)\b/i],
  },
  {
    intent: 'subscription_account',
    patterns: [/\b(subscription|subscribe|account|login|password|email code)\b/i],
  },
  {
    intent: 'complaint_issue',
    patterns: [/\b(problem|issue|complaint|not working|bad|wrong|broken|missing)\b/i],
  },
  {
    intent: 'collaboration_gifting',
    patterns: [/\b(collab|collaboration|influencer|ambassador|gift|sample|pr package)\b/i],
  },
];

export function detectChatAnalyticsIntent(text: unknown): ChatAnalyticsIntent {
  if (typeof text !== 'string' || !text.trim()) return 'general_support';
  for (const { intent, patterns } of INTENT_PATTERNS) {
    if (patterns.some(pattern => pattern.test(text))) return intent;
  }
  return 'general_support';
}

export function inferOutcomeFunnelStage(name: unknown, resourceType: unknown): string {
  const normalizedName = typeof name === 'string' ? name.toLowerCase() : '';
  const normalizedResource = typeof resourceType === 'string' ? resourceType.toLowerCase() : '';
  if (normalizedName.includes('checkout') || normalizedResource === 'checkout') {
    return normalizedName.includes('completed') || normalizedName.includes('converted')
      ? 'converted_order'
      : 'checkout_started';
  }
  if (normalizedName.includes('purchase') || normalizedName.includes('order.converted')) {
    return 'converted_order';
  }
  if (normalizedName.includes('cart') || normalizedResource === 'cart') return 'cart_created';
  if (normalizedResource === 'order') return 'order_action';
  if (normalizedResource === 'subscription') return 'subscription_action';
  return 'business_outcome';
}
